export const notificationType = {
  NEW_MESSAGE: 'NEW MESSAGE',
  APPLICANT_COMPLETED_ONBOARDING: 'APPLICANT COMPLETED ONBOARDING',
  ONBOARDING_DOCUMENT_EXPIRED: 'ONBOARDING DOCUMENT EXPIRED',
  ONBOARDING_DOCS_WAITING: 'ONBOARDING DOCS WAITING',
  ONBOARDING_DOCS_RESEND: 'ONBOARDING DOCS RESEND',
  POST_HIRING_DOCS: 'POST HIRING DOCS',
  PENDING_INTERVIEW_INVITE: 'PENDING INTERVIEW INVITE',
  NO_CALENDAR_BLOCK: 'NO CALENDAR BLOCK',
  PENDING_JOB_OFFER: 'PENDING JOB OFFER',
  WOTC_SURVEY: 'WOTC SURVEY',
  AUTO_ACTION_PERFORMED: 'AUTO ACTION PERFORMED',
  COMPANY_MOVED_TO_SELF_BILLING: 'Company MOVED TO SELF BILLING',
  HIREFLIX_INTERVIEW_COMPLETED: 'HIREFLIX_INTERVIEW_COMPLETED',
  NO_HIREFLIX_CREDIT: 'NO HIRE FLIX CREDIT',
  EIN: 'EIN',
};
